export default "__VITE_ASSET__db0294bc__"